import React from 'react';
import { Box } from '@drivekyte/web-components';
import WPTypography from '@/components/typography/typography';
import Blog from '@/pages/blog/components/main-blog-page';
import { MainBlogPageProps } from '@/pages/blog/components/main-blog-page/types';
import { getStaticProps } from '@/pages/blog/utils/main-page';

const BlogIndexPage = (props: MainBlogPageProps) => {
  if (!props?.data?.mainPageConfig) {
    return (
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
        minHeight="464px"
        padding="small"
      >
        <WPTypography
          variant="h3"
          color="primary"
          fontFamily="Gilroy"
          fontSize={18}
          lineHeight={18}
          fontWeight={400}
        >
          There was an error fetching the data, please try again later.
        </WPTypography>
      </Box>
    );
  }

  return <Blog {...props} />;
};

export { getStaticProps };
export default BlogIndexPage;
